export const STORE_MODULE_NAME = 'event_card';
export const ADD_REVIEW_IMMEDIATELY = false;
export const ERROR_DEFAULT_TEXT =
  'У нас произошел сбой в работе оборудования. Почитайте, пожалуйста, другие статьи, а позже попробуйте еще раз!';
export const PF_DOD_CERTIFICATE = 'pfdod-info';
export const NO_ITEM_TEXT = 'Пока нет ни одной анкеты';
export const MAIN_ANKETA_DESCRIPTION =
  'Для улучшения качества обучения и достижения лучших результатов просим вас оценить текущую реализацию программы.';
export const SUCCESS_ANKETA_TEXT =
  'Спасибо за оценку. Нам очень важно Ваше мнение!';
export const REQUEST_TOOLTIP = (title) =>
  `Вы подали заявку на обучение по программе опережающей профессиональной подготовки "${title}". Ваша заявка принята, администратор свяжется с вам в течение 5 рабочих дней. Спасибо!`;
export const COMPETTENCE_CARD = 'CompetenceCard';
export const COMPETTENCE_TITLE = 'Компетенции';
export const PROFESSIONS_CARD = 'ProfessionListCard';
export const PROFESSIONS_TITLE = 'Профессии';


// WEBPACK FOOTER //
// ./src/pages/event/card/const.js